<app-news-layout
  title="News"
  img="/assets/img/game/news.svg"
  (closeClick)="onCloseClick()"
>
  <div class="news-wrap">
    <ul>
      <li *ngFor="let newsItem of news">
        {{newsItem}}
      </li>
    </ul>
  </div>
</app-news-layout>
